import React, { useContext, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Spinner from "components/spinner/Spinner";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import { useGetListByMasterIdQuery } from "modules/pvs_activities/redux/service/lists";
import { displayNotification, generateOptionsFromData, sendAPIRequest } from "helpers";
import { useGetTemplatesByIDQuery } from "modules/pvs_activities/redux/service/templates";
import { MissionContext } from "../contexts/MissionTasksContext";

const MissionAddTaskModal = ({ isShow, initModal, missionID }) => {

  const missionContext = useContext(MissionContext);
  const [form, setForm] = useState({
    dform_assigned_for: null,
    d_form_id: null,
    user_id: missionContext.missionManager,
    mission_id: missionID,
    status: 1,
  });
  const { data: taskTypeData } = useGetListByMasterIdQuery({
    id: 39,
  });
  const { data: taskSubTypeData } = useGetTemplatesByIDQuery(form.dform_assigned_for, {
    skip: !form.dform_assigned_for,
  });

  const [isBtnLoading, setIsBtnLoading] = useState(false);

  const taskTypeOptions = useMemo(() => {
    return generateOptionsFromData(taskTypeData ?? [], {
      value: "id",
      label: "list_element_name",
    });
  }, [taskTypeData]);

  const taskSubTypeOptions = useMemo(() => {
    return generateOptionsFromData(taskSubTypeData ?? [], {
      value: "id",
      label: "name",
    });
  }, [taskSubTypeData]);

  const handlePopupTaskTypeValueChange = (val) => {
    setForm({ ...form, dform_assigned_for: val, d_form_id: null });
  };

  const handlePopupSubTaskTypeValueChange = (val) => {
    setForm({ ...form, d_form_id: val });
  };

  const handleSave = async () => {
    console.log(form);

    try {
      setIsBtnLoading(true);
      const data = await sendAPIRequest(`/api/pvsa/movement`, "POST", form);
      const response = await data.json();
      if (response.success) {
        setIsBtnLoading(false);
        initModal();
        missionContext.taskTrigger();
        displayNotification("success", `Successfully Create Task`);
      } else {
        setIsBtnLoading(false);
        displayNotification("error", `Error creating a task`);
      }
    } catch (e) {
      setIsBtnLoading(false);
      displayNotification("error", `Error creating a task`);
      console.log(e);
    }
  };

  return (
    <Modal show={isShow}>
      <Modal.Header closeButton onClick={() => initModal()}>
        <Modal.Title>Add Mission Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AutoCompleteDropdown
          showClearIcon={false}
          error={false}
          required={false}
          multiple={false}
          label={"Select Task Type"}
          hasselectall={false}
          options={taskTypeOptions}
          onChange={(event, value) => {
            handlePopupTaskTypeValueChange(value.value);
          }}
          value={form?.dform_assigned_for ? taskTypeOptions.find((r) => r.value == form?.dform_assigned_for) : null}
        />
        <AutoCompleteDropdown
          showClearIcon={false}
          error={false}
          required={false}
          multiple={false}
          label={"Select Sub-Task Type"}
          hasselectall={false}
          options={taskSubTypeOptions}
          onChange={(event, value) => {
            handlePopupSubTaskTypeValueChange(value.value);
          }}
          value={form?.d_form_id ? taskSubTypeOptions.find((r) => r.value == form?.d_form_id) : null}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="dark" onClick={handleSave}>
          {isBtnLoading ? (
            <Spinner message="Saving..." />
          ) : (
            <>
              <i className="fa-sharp fa-solid fa-check"></i>
              Save
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MissionAddTaskModal;
